import { useOrganizations } from '@consigli/hooks';
import { Organization } from '@consigli/types';
import { useState } from 'react';

import { Search, Combobox } from '@/components';

import type { ProjectFilters } from '../types';

const packageTypeOptions = [
  {
    label: 'Package Type',
    options: [
      { label: 'Document Package', value: 'DOCUMENT_PACKAGE' },
      { label: 'Building Package', value: 'BUILDING_PACKAGE' },
      { label: 'Layout Optimization', value: 'LAYOUT_OPTIMIZATION' },
    ],
  },
];

interface ProjectFiltersProps {
  searchTerm: string;
  handleSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFiltersChange?: (filters: ProjectFilters) => void;
}

export const ProjectFiltersComponent = ({
  searchTerm,
  handleSearch,
  onFiltersChange,
}: ProjectFiltersProps) => {
  const [selectedPackageType, setSelectedPackageType] = useState<string[]>([]);
  const [selectedOrganization, setSelectedOrganization] = useState<Organization[]>([]);

  const { organizations } = useOrganizations();

  const handlePackageTypeChange = (values: string[]) => {
    setSelectedPackageType(values);
    onFiltersChange?.({
      packageTypes: values,
      organization: selectedOrganization,
    });
  };

  const handleOrganizationChange = (values: string[]) => {
    const selectedOrgs = organizations.filter((org) => values.includes(org.id));
    setSelectedOrganization(selectedOrgs);
    onFiltersChange?.({
      packageTypes: selectedPackageType,
      organization: selectedOrgs,
    });
  };

  return (
    <div className="flex gap-2 flex-wrap">
      <Search
        text={searchTerm}
        placeholder="Search for name, org name or id"
        onChange={(e) => handleSearch(e)}
        className="w-[300px]"
      />
      <Combobox
        optionGroups={packageTypeOptions}
        value={selectedPackageType}
        onValueChange={handlePackageTypeChange}
        placeholder="Package type"
        fallbackLabel={''}
        className="w-[250px]"
      />
      <Combobox
        optionGroups={[
          {
            label: 'Organizations',
            options: organizations.map((org) => ({
              label: org.name,
              value: org.id,
            })),
          },
        ]}
        value={selectedOrganization.map((org) => org.id)}
        onValueChange={handleOrganizationChange}
        placeholder="Select organization"
        fallbackLabel="No organizations found"
        className="w-[250px]"
      />
    </div>
  );
};
